var map = {
	"./X33-Mall_small.jpg": 900,
	"./all-active.svg": 901,
	"./all.svg": 902,
	"./apple-watch.png": 903,
	"./b-headphone.png": 904,
	"./coin.svg": 905,
	"./delete-btn.svg": 906,
	"./iphone-13.webp": 2298,
	"./iphone-pink.png": 907,
	"./love-active.svg": 908,
	"./love.svg": 909,
	"./mobile-bg.jpg": 910,
	"./mobile-bg.webp": 2299,
	"./price-high-active.svg": 911,
	"./price-high.svg": 912,
	"./price-low-active.svg": 913,
	"./price-low.svg": 914,
	"./rewards-dnp-cn.webp": 2300,
	"./rewards-dnp.webp": 2301,
	"./shopping-cart.svg": 915,
	"./star.svg": 916,
	"./x33mall-banner-cn.jpg": 917,
	"./x33mall-banner-cn.webp": 2302,
	"./x33mall-banner-id.jpg": 918,
	"./x33mall-banner-ms.jpg": 919,
	"./x33mall-banner-ms.webp": 2303,
	"./x33mall-banner.jpg": 920,
	"./x33mall-banner.webp": 2304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 922;